import React, { useState, useContext } from 'react';
import DashboardLayout from '../Components/DashboardLayout';
import { useLocation, useNavigate } from 'react-router-dom';

import { MyContext } from '../context/MyContext';

import { callApiGet } from '../Helper/Network';
import { HyappDatePicker, HyappSelect } from '../Helper/Form';
import { Button } from 'react-bulma-components';

import { useTranslation } from '../locale/useTranslation';

const convertDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1);
    const day = (date.getDate());
    return year.toString() + "-" + month.toString().padStart(2, '0') + "-" + day.toString().padStart(2, '0');
}


function Statistics(props) {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const location = useLocation().pathname.replace("/edit", "").replace("/view", "").replace("/graph", "");
    const { loggedUser, etablissements } = useContext(MyContext);
    const listEtablissement = [{value:-1, label: t("Tous")}].concat(etablissements);
    const [statEtablissement, setStatEtablissement] = useState(null);
    const [config, setConfig] = useState(undefined);


    var dataTypes = [
        {
            "value": "nonconformite",
            "label": t("Non-conformité")
        }]

    if (loggedUser.role_role_id === 0 || loggedUser.role_role_id === 10) {
        dataTypes.push(
        {
            "value": "connexion",
            "label": t("Connexions")
        });
    }
    


    var df = new Date();
    df.setHours(0, 0, 0, 0);
    df.setMonth(df.getMonth() - 1)
    var dt = new Date();
    dt.setHours(0, 0, 0, 0);

    const [dateFrom, setDateFrom] = useState(convertDate(df));
    const [dateTo, setDateTo] = useState(convertDate(dt));
    const [dataType, setDataType] = useState(dataTypes[0]);

    const loadData = async () => {
        try {
            var url = location;

            //load data element
            const res = await callApiGet(url + "/stats?dateFrom=" + dateFrom + "&dateTo=" + dateTo +"&dataType=" + dataType.value + "&et=" + (statEtablissement?.value ?? -1), navigate);
            if (res) {
                setConfig(res);
            }
        }
        catch (error) {

        }
    }

    return (
        <>
            <div className="columns is-multiline is-vcentered">
                <div className="column is-one-fifth label-right">
                    <label className="label">{t("Du :")}</label>
                </div>
                <div className="column is-four-fifths edit-value">
                    <HyappDatePicker value={dateFrom} callback={setDateFrom} />
                </div>
                <div className="column is-one-fifth label-right">
                    <label className="label">{t("Au :")}</label>
                </div>
                <div className="column is-four-fifths edit-value">
                    <HyappDatePicker value={dateTo} callback={setDateTo} />
                </div>
                <HyappSelect label={"Type de données"} data={dataTypes} callback={setDataType} value={dataType}/>
                {
                    dataType.value !== 'connexion' ?
                        <HyappSelect label={"Etablissement"} data={listEtablissement} callback={setStatEtablissement} value={statEtablissement}/>
                        :null
                }
            </div>
            <Button className="button is-success" onClick={loadData}>{t("Afficher le graphique")}</Button>
            <div>
                {
                    config && <DashboardLayout sections={config.sections} />
                }
                
            </div>
        </>
    );
}

export default Statistics;